import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import { format, parseISO, isValid } from "date-fns";
import { de, enGB } from "date-fns/locale";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { useApp } from "@/context/AppContext";

const CLS = {
  months: "flex", month: "space-y-3",
  caption: "flex justify-between items-center px-1", caption_label: "font-display uppercase tracking-wide text-base",
  nav: "flex items-center gap-1", nav_button: "gg-icon-btn !w-8 !h-8", nav_button_previous: "order-first", nav_button_next: "",
  table: "w-full border-collapse", head_row: "flex", head_cell: "w-9 font-display uppercase text-[10px] tracking-widest text-muted-foreground",
  row: "flex w-full mt-1", cell: "p-0 w-9 h-9",
  day: "w-9 h-9 font-display text-sm hover:bg-muted transition-colors",
  day_selected: "!bg-primary !text-primary-foreground", day_today: "underline decoration-primary decoration-2",
  day_outside: "text-muted-foreground/50", day_disabled: "text-muted-foreground/40 line-through hover:bg-transparent", day_hidden: "invisible",
};

export default function DatePicker({ value, onChange, min, required, placeholder, testid, className = "" }) {
  const { lang } = useApp();
  const [open, setOpen] = useState(false);
  const locale = lang === "de" ? de : enGB;
  const date = value ? parseISO(value) : undefined;
  const ok = date && isValid(date);
  const minDate = min ? parseISO(min) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={`gg-input flex items-center justify-between gap-2 text-left ${ok ? "" : "text-muted-foreground"} ${className}`} data-testid={testid} aria-required={required}>
          <span className="font-display uppercase tracking-wide">{ok ? format(date, "EEE d MMM yyyy", { locale }) : placeholder || "—"}</span>
          <CalendarDays className="w-4 h-4 text-primary shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-3 border border-foreground rounded-none bg-background shadow-none" data-testid={`${testid}-popover`}>
        <DayPicker mode="single" locale={locale} weekStartsOn={1} selected={ok ? date : undefined} defaultMonth={ok ? date : minDate}
          disabled={minDate ? { before: minDate } : undefined} classNames={CLS}
          components={{ IconLeft: () => <ChevronLeft className="w-4 h-4" />, IconRight: () => <ChevronRight className="w-4 h-4" /> }}
          onSelect={d => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
        {value && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="eyebrow mt-2 hover:text-primary" data-testid={`${testid}-clear`}>×</button>}
      </PopoverContent>
    </Popover>
  );
}
